import React, { useState, useEffect } from "react"
import MUIDataTable from "mui-datatables"
import CustomLoader from "../../common/Loader"
import { loadProjectLinkingAppWhitelist, editProjectLinkingAppWhitelist } from "../../../services/projectService"
import { Modal } from "react-bootstrap";
import * as Icon from "react-feather";
import { toaster } from '../../../config';
import LinkingAppWhitelistDeleteDialog from "./LinkingAppWhitelistDeleteDialog";

const ProjectLinkingAppWhitelist = ({Project_ID}) => {
    const [loading, setLoading] = useState(true)
    const [columns, setColumns] = useState([])
    const [data, setData] = useState([])
    const [options, setOptions] = useState({
        download: true,
        downloadOptions: { filename: 'ThriveLinkingAppWhitelist.csv', separator: ','},
        print: false,
        selectableRowsHeader: false,
        selectableRows: 'none',
        pagination: true,
        rowsPerPageOptions: [10, 15, 30, 50, 100],
        filter: false,
        viewColumns: false
    })
    const [hasAccess, setHasAccess] = useState(false)
    const [openAddModal, setOpenAddModal] = useState(false)
    const [addUsername, setAddUsername] = useState('')
    const [editResponse, setEditResponse] = useState('')
    const [hideEditResponse, setHideEditResponse] = useState(true)

    useEffect(() => {
        loadLinkingAppWhitelist()
    }, [])

    const loadLinkingAppWhitelist = () => {
        setLoading(true)
        loadProjectLinkingAppWhitelist(Project_ID)
        .then((response) => {
            if (typeof Object.values(response.data[0])[0] === "string" && Object.values(response.data[0])[0].includes("Error")) {
                setHasAccess(false)
            } else {
                let columns = Object.keys(response.data[0])
                columns = columns.map((col) => {
                    return {
                        name: col,
                        options: {
                            filter: [].includes(col) ? false : true,
                            setCellHeaderProps: value => ({ style: { 'color': '#0061F2' } }),
                            setCellProps: value => ({ style: { 'color': '#687281', 'fontSize': 'medium', 'fontFamily': 'Metropolis' } })
                        }
                    }
                })
                columns.push({
                    name: 'Delete',
                    options: {
                        filter: false,
                        sort: false,
                        setCellHeaderProps: value => ({ style: { 'color': '#0061F2' } }),
                        setCellProps: value => ({ style: { 'color': '#687281', 'fontSize': 'medium', 'fontFamily': 'Metropolis' } }),
                        customBodyRenderLite: (dataIndex) => {
                            return (
                                <LinkingAppWhitelistDeleteDialog Username={data[dataIndex][0]} handleDelete={handleEditWhitelist}/>
                            );
                          }
                    }
                })
                setColumns(columns)
                let data = response.data.map((obj) => {
                    return Object.values(obj)
                })
                setData(data) 
                setHasAccess(true)
            }
            setLoading(false)
        })
    }

    const handleEditWhitelist = async (username, action) => {
        const { data } = await editProjectLinkingAppWhitelist(username, action)
        if (data.includes('Error')) {
            action === 1 && setEditResponse(data)
            action === 2 && toaster('error', data)
        } else {
            action === 1 && setEditResponse('User is added to linking app whitelist.')
            if (action === 2) {
                toaster('success', 'User is removed from linking app whitelist.')
                loadLinkingAppWhitelist()
            }
        }
        action === 1 && setHideEditResponse(false)
    }

    const handlePopUpClose = () => {
        setOpenAddModal(false)
        setAddUsername('')
        setEditResponse('')
        setHideEditResponse(true)
        loadLinkingAppWhitelist()
    }

    if (loading) {
        return <CustomLoader loading={loading} />
    } else {
        return <>
            {hasAccess ? <><div className="ml-4">
                <button 
                    className="btn btn-primary mb-2 mt-2"
                    onClick={() => setOpenAddModal(true)}
                >
                    Add User
                </button>
                <Modal
                    size='xl'
                    show={openAddModal}
                    onHide={() => handlePopUpClose()}
                >
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body className='container'>
                        <p>Please enter the username to be added to linking app whitelist:</p>
                        <input
                            key={'AddUser'}
                            type='text'
                            className='form-control'
                            value={addUsername}
                            onChange={(e) => setAddUsername(e.target.value)}
                        />
                        <button 
                            className="btn btn-primary mb-2 mt-3"
                            onClick={() => handleEditWhitelist(addUsername, 1)}
                        >
                            Submit
                        </button>
                        <p hidden={hideEditResponse}>{editResponse}</p>
                    </Modal.Body>
                </Modal>
            </div>
            <div className='card-body' key = {options} id='customDT'>
                <MUIDataTable
                    key={options}
                    title='Thrive Linking App Whitelist'
                    columns={columns}
                    data={data}
                    options={options}
                />
            </div>
            </> : <>No access. Please contact Thrive team if access is needed.</>}
        </>
    }
}

export default ProjectLinkingAppWhitelist